// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Pepi","selected":"Chip_selected__3XCTr"};